import { Outlet } from 'react-router-dom';

import { Frame, Page } from '@servicetitan/design-system';

export const PublicLayout = () => {
  return (
    <Frame style={{ height: '100%', isolation: 'isolate' }}>
      <Page id='public-layout' spacing='none' maxWidth='wide'>
        <Outlet />
      </Page>
    </Frame>
  );
};

export default PublicLayout;
